import {useCallback, useState} from 'react';

export const useValueWithPristineFlag = (initialState = '') => {
  const [value, setValue] = useState(initialState);
  const [isPristine, setIsPristine] = useState(true);
  const reset = useCallback(() => setIsPristine(true), []);
  const onChange = useCallback(newVal => {
    setValue(newVal);
    setIsPristine(false);
  }, []);
  return [value, onChange, isPristine, reset];
};
export const useNewValueWithPristineFlag = () => {
  const [value, onChange, isPristine, resetPristine] = useValueWithPristineFlag();
  const reset = useCallback(() => {
    onChange('');
    resetPristine();
  }, [onChange, resetPristine]);
  return [value, onChange, isPristine, reset];
};
